import API from "../api";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async requestMiniExtract(): Promise<any> {
      const { data } = await API.getMiniExtract();
      return data;
    },
    async requestAbout(): Promise<any> {
      const { data } = await API.getAbout();
      return data;
    },
    async requestSurveyMonkey(context: any, payload: any): Promise<any> {
      const { data } = await API.getSurveyMonkey(payload);
      return data;
    },
  },
  modules: {},
};
